<template>
  <div class="form-container userform-container">
    <h1>利用者情報の登録</h1>
    <form @submit.prevent="registerUser">
      <table class="info-table">
        <tbody>
          <tr>
            <td><label class="required-label">地域</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="newUser.region" :class="{ 'input-error': errors.region }" @change="getAffiliatedOrgs" :disabled="disabledStates.systemAdmin">
                <option value="" disabled>地域を選択してください</option>
                <option 
                  v-for="region in regions" 
                  :key="region.region_id" 
                  :value="region.region_id">
                  {{ region.region_nm }}
                </option>
              </select>
              <span v-if="errors.region" class="error-message">{{ errors.region }}</span>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">利用者ID</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.userId" type="text" :class="{ 'input-error': errors.userId }" maxlength="8" @blur="validateOnBlur('userId', newUser.userId)"/>
              <span v-if="errors.userId" class="error-message">{{ errors.userId }}</span>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">パスワード</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.password" type="password" :class="{ 'input-error': errors.password }" maxlength="40" @blur="validateOnBlur('password', newUser.password)"/>
              <span v-if="errors.password" class="error-message">{{ errors.password }}</span>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">パスワード(確認用)</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.passwordConfirm" type="password" :class="{ 'input-error': errors.passwordConfirm }" maxlength="40" @blur="validateOnBlur('password', newUser.passwordConfirm)"/>
              <span v-if="errors.passwordConfirm" class="error-message">{{ errors.passwordConfirm }}</span>
            </td>
          </tr>
          <tr>
            <td><label>利用者区分</label></td>
            <td><label>:</label></td>
            <td>
              <div >
                <div :class="{ 'radio-group-error': errors.userType }">
                  <label><input type="radio" value="システム管理者" v-model="newUser.userType" :disabled="disabledStates.systemAdmin" @change="validateOnBlur('userType', newUser.userType)"/> システム管理者</label>
                  <label><input type="radio" value="行政機関" v-model="newUser.userType" :disabled="disabledStates.admin" @change="handleAdminSelectionChange" /> 行政機関</label>
                  <label><input type="radio" value="その他" v-model="newUser.userType" :disabled="disabledStates.other" @change="handleOtherSelectionChange" @input="validateOnBlur('userType', newUser.userType)"/> その他</label>
                </div>
                <span v-if="errors.userType" class="error-message">{{ errors.userType }}</span>
              </div>
              <div v-if="newUser.userType === '行政機関'">
                <label><input type="radio" value="行政機関管理者" v-model="newUser.adminType" /> 行政機関管理者</label>
                <label><input type="radio" value="行政機関メンバー" v-model="newUser.adminType" /> 行政機関メンバー</label>
              </div>
              <div v-if="newUser.userType === 'その他'">
                <label><input type="radio" value="捕獲者" v-model="newUser.otherType"  :disabled="disabledStates.admin"/> 捕獲者</label>
                <label><input type="radio" value="見える化管理者" v-model="newUser.otherType" /> 見える化管理者</label>
                <label><input type="radio" value="見える化メンバー" v-model="newUser.otherType" :disabled="disabledStates.visualizationMember"/> 見える化メンバー</label>
              </div>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">メールアドレス</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.email" type="email" :class="{ 'input-error': errors.email }" maxlength="50" @blur="validateOnBlur('email', newUser.email)"/>
              <span v-if="errors.email" class="error-message">{{ errors.email }}</span>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">利用者氏名（漢字）</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.fullNameKanji" type="text" :class="{ 'input-error': errors.fullNameKanji }" maxlength="50" @blur="validateOnBlur('fullNameKanji', newUser.fullNameKanji)"/>
              <span v-if="errors.fullNameKanji" class="error-message">{{ errors.fullNameKanji }}</span>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">利用者氏名（カナ）</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.fullNameKana" type="text" :class="{ 'input-error': errors.fullNameKana }" maxlength="50" @blur="validateOnBlur('fullNameKana', newUser.fullNameKana)"/>
              <span v-if="errors.fullNameKana" class="error-message">{{ errors.fullNameKana }}</span>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">郵便番号</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.zip" type="text" :class="{ 'input-error': errors.zip }" maxlength="8" @blur="validateOnBlur('zip', newUser.zip)"/>
              <span v-if="errors.zip" class="error-message">{{ errors.zip }}</span>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">住所１（市町村まで）</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.address1" type="text" :class="{ 'input-error': errors.address1 }" maxlength="20" @blur="validateOnBlur('address1', newUser.address1)"/>
              <span v-if="errors.address1" class="error-message">{{ errors.address1 }}</span>
            </td>
          </tr>
          <tr>
            <td><label>住所２</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.address2" type="text" :class="{ 'input-error': errors.address2 }" maxlength="20" @blur="validateOnBlur('address2', newUser.address2)"/>
              <span v-if="errors.address2" class="error-message">{{ errors.address2 }}</span>
            </td>
          </tr>
          <tr class="birthday-row">
            <td><label class="required-label">生年月日</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="newUser.birthday.type" :class="{ 'input-error': errors['birthday.type'] }"  @blur="validateOnBlur('birthday.type', newUser.birthday.type)">
                <option disabled value="">年号を選択</option>
                <option value="西暦">西暦</option>
              </select>
              <input v-model="newUser.birthday.year" type="number" min="1" placeholder="年" :class="{ 'input-error': errors['birthday.year'] }"  maxlength="4" @blur="validateOnBlur('year', newUser.year)"/>
              <input v-model="newUser.birthday.month" type="number" min="1" max="12" placeholder="月" :class="{ 'input-error': errors['birthday.month'] }" maxlength="2" @blur="validateOnBlur('month', newUser.month)"/>
              <input v-model="newUser.birthday.day" type="number" min="1" max="31" placeholder="日" :class="{ 'input-error': errors['birthday.day'] }" maxlength="2" @blur="validateOnBlur('day', newUser.day)"/>
              <span v-if="errors['birthday.type']" class="error-message">{{ errors['birthday.type'] }}</span>
              <span v-if="errors['birthday.year']" class="error-message">{{ errors['birthday.year'] }}</span>
              <span v-if="errors['birthday.month']" class="error-message">{{ errors['birthday.month'] }}</span>
              <span v-if="errors['birthday.day']" class="error-message">{{ errors['birthday.day'] }}</span>
              <span v-if="errors.birthday" class="error-message">{{ errors.birthday }}</span>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">性別</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="newUser.sex" :class="{ 'input-error': errors.sex }" @blur="validateOnBlur('sex', newUser.sex)">
                <option value="不明">不明</option>
                <option value="男性">男性</option>
                <option value="女性">女性</option>
              </select>
              <span v-if="errors.sex" class="error-message">{{ errors.sex }}</span>
            </td>
          </tr>
          <tr>
            <td><label>固定電話番号</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.homePhone" type="text" :class="{ 'input-error': errors.homePhone }" maxlength="11" @blur="validateOnBlur('homePhone', newUser.homePhone)"/>
              <span v-if="errors.homePhone" class="error-message">{{ errors.homePhone }}</span>
            </td>
          </tr>
          <tr>
            <td><label>スマートフォン番号</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.mobilePhone" type="text" :class="{ 'input-error': errors.mobilePhone }" maxlength="11" @blur="validateOnBlur('mobilePhone', newUser.mobilePhone)"/>
              <span v-if="errors.mobilePhone" class="error-message">{{ errors.mobilePhone }}</span>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">所在部署名称</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.department" type="text" :class="{ 'input-error': errors.department }"  maxlength="20" @blur="validateOnBlur('department', newUser.department)"/>
              <span v-if="errors.department" class="error-message">{{ errors.department }}</span>
            </td>
          </tr>
          <tr>
            <td><label>備考</label></td>
            <td><label>:</label></td>
            <td>
              <textarea v-model="newUser.notes" :class="{ 'input-error': errors.notes }"  maxlength="200" @blur="validateOnBlur('notes', newUser.notes)"></textarea>
              <span v-if="errors.notes" class="error-message">{{ errors.notes }}</span>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">直属行政機関</label></td>
            <td><label>:</label></td>
            <td>
              <select 
                v-model="newUser.directAdminOrg" 
                :class="{ 'input-error': errors.directAdminOrg }" 
                @blur="validateOnBlur('directAdminOrg', newUser.directAdminOrg)" 
                :disabled="disabledStates.systemAdmin"
                @change="selectDirectAdminOrg()"
              >
                <option disabled value="">選択してください</option>
                <option v-for="org in directAdminOrgs" :key="org.id" :value="org.id">
                  {{ org.name }}
                </option>
              </select>
              <span v-if="errors.directAdminOrg" class="error-message">{{ errors.directAdminOrg }}</span>
            </td>
          </tr>
          <tr>
            <td><label>所属行政機関の選択</label></td>
            <td><label>:</label></td>
            <td>
              <div class="affiliated-admin-container">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <select 
                          v-model="selectedAffiliatedOrg" 
                          multiple 
                          size="7" 
                          style="width: 200px; height: 160px;" 
                          :disabled="!newUser.directAdminOrg"
                        >
                          <option 
                            v-for="(org, index) in filteredAffiliatedAdminOrgs" 
                            :key="org.id || index" 
                            :value="org.id"
                          >
                            {{ org.name }}
                          </option>
                        </select>
                      </td>
                      <td align="center" class="button-column-container">
                        <button 
                          type="button" 
                          @click="addAllAffiliatedOrgs" 
                          :disabled="!newUser.directAdminOrg"
                        >全登録</button>
                        <button 
                          type="button" 
                          @click="addOneAffiliatedOrg" 
                          :disabled="!newUser.directAdminOrg"
                        >＞＞</button>
                        <button 
                          type="button" 
                          @click="removeOneAffiliatedOrg" 
                          :disabled="!newUser.directAdminOrg"
                        >＜＜</button>
                        <button 
                          type="button" 
                          @click="removeAllAffiliatedOrgs" 
                          :disabled="!newUser.directAdminOrg"
                        >全解除</button>
                      </td>
                      <td>
                        <select 
                          v-model="selectedAffiliatedOrg" 
                          multiple 
                          size="7" 
                          style="width: 200px; height: 160px;" 
                          :class="{ 'input-error': errors.selectedAffiliatedOrgs }" 
                          :disabled="!newUser.directAdminOrg"
                        >
                          <option 
                            v-for="org in newUser.selectedAffiliatedOrgs" 
                            :key="org.id" 
                            :value="org.id"
                          >
                            {{ org.name }}
                          </option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <span 
                v-if="errors.selectedAffiliatedOrgs" 
                class="error-message" 
                style="text-align: right;"
              >{{ errors.selectedAffiliatedOrgs }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
    <div class="button-container">
      <button type="submit" class="register-button" @click="registerUser">登録</button>
    </div>
  </div>
</template>

<script>
import '@/assets/styles/User.css';
import userValidationMixin from '@/mixins/userValidationMixin';
import axios from "axios";

export default {
  mixins: [userValidationMixin],
  name: "UserInfo",
  data() {
    return {
      regions: [],
      section: null,
      directAdminOrgs: [],
      affiliatedAdminOrgs: [],
      selectedAffiliatedOrg: [],
      userTypeMapping: {
        "システム管理者": "0000",
        "行政機関": "01",
        "その他": "02",
      },
      adminTypeMapping: {
        "行政機関管理者": "00",
        "行政機関メンバー": "01",
      },
      otherTypeMapping: {
        "捕獲者": "01",
        "見える化管理者": "10",
        "見える化メンバー": "11",
      },
      newUser: {
        region: '',
        userId: '',
        password: '',
        passwordConfirm: '',
        userType: '',
        adminType: [],
        otherType: [],
        email: '',
        fullNameKanji: '',
        fullNameKana: '',
        zip: '',
        address1: '',
        address2: '',
        birthday: { type: '', year: '', month: '', day: '' },
        sex: '',
        homePhone: '',
        mobilePhone: '',
        department: '',
        notes: '',
        directAdminOrg: '',
        selectedAffiliatedOrgs: [],
        userType: '',
        adminType: '',
        otherType: '',
      },
      disabledStates: {
        systemAdmin: false,
        admin: false,
        other: false,
        visualizationMember: false,
      },
      isErrorMode: false, // エラーモードフラグ
      errors: {}, // エラーメッセージを格納
    };
  },
  created() {
    this.updateDisabledStates();
  },
  mounted() {
    const section = localStorage.getItem('section');
    if (section != '0000') {
      this.getAffiliatedOrgs();
    }
    this.getRegionDetails();
    this.updateDisabledStates();
  },
  watch: {
    directAdminOrgs(newVal, oldVal) {
      if (Array.isArray(newVal) && newVal.length > 0 && !this.newUser.directAdminOrg) {
        this.newUser.directAdminOrg = newVal[0].id; // 1件目をセット
        return
      }
    },
    regions(newVal) {
      const section = localStorage.getItem("section");
      if (section != '0000') {
        this.newUser.region = this.regions[0].region_id; // 1件目をセット
      }
      return
    },
    "newUser.userType"(newVal) {
      this.updateDisabledStates();
    },
    "newUser.region"(newVal) {
      this.getAffiliatedOrgs();
    },
  },
  computed: {
    // 直属行政機関を除外した所属行政機関リスト
    filteredAffiliatedAdminOrgs() {
      return this.affiliatedAdminOrgs.filter(
        (org) => org.id !== this.newUser.directAdminOrg
      );
    }
  },
  methods: {
    updateAdminType() {
      this.newUser.otherType = [];
    },
    updateOtherType() {
      this.newUser.adminType = [];
    },
    selectDirectAdminOrg() {
      this.selectedAffiliatedOrg = [];
      this.newUser.selectedAffiliatedOrgs = [];
      this.affiliatedAdminOrgs = this.directAdminOrgs.filter(org =>
        org.id !== this.newUser.directAdminOrg
      );
    },
    addOneAffiliatedOrg() {
      this.selectedAffiliatedOrg.forEach((orgId) => {
        const org = this.affiliatedAdminOrgs.find((o) => o.id === orgId);
        if (org && !this.newUser.selectedAffiliatedOrgs.includes(org)) {
          this.newUser.selectedAffiliatedOrgs.push(org);
          // 右に移動したので、左リストから削除
          this.affiliatedAdminOrgs = this.affiliatedAdminOrgs.filter(
            (o) => o.id !== orgId
          );
        }
      });
      this.selectedAffiliatedOrg = [];
    },
    removeOneAffiliatedOrg() {
      this.selectedAffiliatedOrg.forEach((orgId) => {
        const org = this.newUser.selectedAffiliatedOrgs.find(
          (o) => o.id === orgId
        );
        if (org && !this.affiliatedAdminOrgs.includes(org)) {
          this.affiliatedAdminOrgs.push(org);
          // 左に戻したので、右リストから削除
          this.newUser.selectedAffiliatedOrgs =
            this.newUser.selectedAffiliatedOrgs.filter((o) => o.id !== orgId);
        }
      });
      this.selectedAffiliatedOrg = [];
    },
    addAllAffiliatedOrgs() {
      // 全て移動
      this.newUser.selectedAffiliatedOrgs = [...this.affiliatedAdminOrgs];
      this.affiliatedAdminOrgs = [];
    },
    removeAllAffiliatedOrgs() {
      // 右側の選択肢を左側に移動
      this.affiliatedAdminOrgs = [...this.affiliatedAdminOrgs, ...this.newUser.selectedAffiliatedOrgs];

      // 重複を排除（IDで一意なリストを作成）
      this.affiliatedAdminOrgs = this.affiliatedAdminOrgs.filter((org, index, self) =>
        index === self.findIndex((o) => o.id === org.id)
      );

      // 右側の選択肢をクリア
      this.newUser.selectedAffiliatedOrgs = [];
    },
    // 行政機関選択専用のチェンジメソッド
    handleAdminSelectionChange() {
      // 1. 行政機関関連の状態を更新
      this.updateAdminType();

      // 2. バリデーションを実行
      this.validateOnChange('userType', this.newUser.userType);
    },
    // その他選択専用のチェンジメソッド
    handleOtherSelectionChange() {
      // 1. その他関連の状態を更新
      this.updateOtherType();

      // 2. バリデーションを実行
      this.validateOnChange('userType', this.newUser.userType);
    },
    // ラジオボタン選択時の再バリデーションチェック
    validateOnChange(field, value) {
      const result = this.validateForm([
        {
          field,
          value,
          isRequired: true,
        },
      ]);
      this.errors[field] = result[field] || ''; // エラーがなければ解除
    },
    // フォーカスアウト時の再バリデーションチェック
    validateOnBlur(field, value) {
      if (!this.isErrorMode) return; // エラーモードがオフの場合は処理しない

      const result = this.validateForm([{ field, value, isRequired: true }]);
      this.errors[field] = result[field] || ''; // エラーがなければエラーを解除
    },
    // 所属行政機関の選択変更時のバリデーション
    validateSelectedAffiliatedOrgs(field) {
      // 配列チェックの場合は `selectedAffiliatedOrgs` を使用
      const result = this.validateForm([
        {
          field,
          value: this.newUser.selectedAffiliatedOrgs, // 正確な配列をバリデーション
          isRequired: true,
        },
      ]);

      // エラーの更新
      this.errors[field] = result[field] || ''; // エラーがなければ解除
    },
    updateDisabledStates() {
      // セクションに基づいて無効状態を設定
      const section = localStorage.getItem("section");
      if (section === '0000') {
        this.disabledStates = {
          systemAdmin: false,
          admin: false,
          other: false,
          visualizationMember: false,
        };
      } else if (section === '0100') {
        this.disabledStates = {
          systemAdmin: true,
          admin: false,
          other: false,
          visualizationMember: false,
        };
      } else if (section === '0210') {
        this.disabledStates = {
          systemAdmin: true,
          admin: true,
          other: false,
          visualizationMember: false,
        };
      } else {
        // デフォルト設定
        this.disabledStates = {
          systemAdmin: true,
          admin: true,
          other: true,
          visualizationMember: true,
        };
      }
    },
    loadSectionFromLocalStorage() {
      this.updateRadioButtonState(); // 状態を更新
    },
    async getRegionDetails() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId"); // ローカルストレージから userId を取得
      const section = localStorage.getItem("section");
      const regionId = localStorage.getItem("regionId");

      if (!token) {
        alert("ログインしていません。再度ログインしてください。");
        return;
      }

      if (!userId) {
        alert("ログイン情報が見つかりません。再度ログインしてください。");
        return;
      }

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/regionSearch/getList`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          if (section === '0000') {
            this.regions = response.data.data;
          } else {
            this.regions = response.data.data.filter(org => org.region_id === regionId);
          }
        } else {
          alert(
            `データの取得に失敗しました。ステータスコード: ${response.status}`
          );
        }
      } catch (error) {
        console.error("エラー詳細:", error.response || error.message);
        alert("タイムアウトです。再ログインしてください。");
      }
    },
    async getAffiliatedOrgs() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId"); // ローカルストレージから userId を取得
      const section = localStorage.getItem("section");
      const regionId = localStorage.getItem("regionId");

      if(!this.newUser.region) {
        return;
      }

      if (!token) {
        alert("ログインしていません。再度ログインしてください。");
        return;
      }

      if (!userId) {
        alert("ログイン情報が見つかりません。再度ログインしてください。");
        return;
      }

      try {
        let requestData;
        if (section === '0000') {
          requestData = { id: userId, editId : this.newUser.userId, regionId : this.newUser.region }
        } else {
          requestData = { id: userId, editId : userId, regionId : regionId }
        }
        // console.log(requestData);
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/addminAgencyRegister/getRegionList`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // console.log(response);

        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          if (section === '0000') {
            this.directAdminOrgs = response.data.data;
          } else {
            this.directAdminOrgs = response.data.data.filter(org => 
              (org.sourceType === 'direct')
            );
            this.affiliatedAdminOrgs = response.data.data.filter(org =>
              !this.newUser.selectedAffiliatedOrgs.some(selectedOrg => selectedOrg.id === org.id) &&
              org.sourceType === 'affiliation'
            );
          }
        } else {
          alert(
            `データの取得に失敗しました。ステータスコード: ${response.status}`
          );
        }
      } catch (error) {
        console.error("エラー詳細:", error.response || error.message);
        alert("タイムアウトです。再ログインしてください。");
      }
    },
    async registerUser() {
      const fieldsToValidate = [
        { field: "region", label: "地域", value: this.newUser.region, isRequired: true },
        { field: "userId", label: "利用者ID", value: this.newUser.userId, isRequired: true, maxLength: 8 },
        { field: "password", label: "パスワード", value: this.newUser.password, isRequired: true, maxLength: 40 },
        { field: "passwordConfirm", label: "パスワード(確認用)", value: this.newUser.passwordConfirm, isRequired: true, maxLength: 40 },
        { field: "userType", label: "利用者区分", value: this.newUser.userType, isRequired: false },
        { field: "email", label: "メールアドレス", value: this.newUser.email, isRequired: true, maxLength: 50 },
        { field: "fullNameKanji", label: "利用者氏名（漢字）", value: this.newUser.fullNameKanji, isRequired: true, maxLength: 50 },
        { field: "fullNameKana", label: "利用者氏名（カナ）", value: this.newUser.fullNameKana, isRequired: true, maxLength: 50 },
        { field: "zip", label: "郵便番号", value: this.newUser.zip, isRequired: true, maxLength: 8 },
        { field: "address1", label: "住所１（市町村まで）", value: this.newUser.address1, isRequired: true, maxLength: 20 },
        { field: "address2", label: "住所２", value: this.newUser.address2, isRequired: false, maxLength: 20 },
        { field: "birthday.type", label: "年号", value: this.newUser.birthday.type, isRequired: true },
        { field: "birthday", label: "生年月日", value: `${this.newUser.birthday.year}-${this.newUser.birthday.month}-${this.newUser.birthday.day}`, isRequired: false },
        { field: "birthday.year", label: "年", value: this.newUser.birthday.year, isRequired: true, maxLength: 4 },
        { field: "birthday.month", label: "月", value: this.newUser.birthday.month, isRequired: true, maxLength: 2 },
        { field: "birthday.day", label: "日", value: this.newUser.birthday.day, isRequired: true, maxLength: 2 },
        { field: "sex", label: "性別", value: this.newUser.sex, isRequired: true },
        { field: "homePhone", label: "固定電話番号", value: this.newUser.homePhone, isRequired: false, maxLength: 11 },
        { field: "mobilePhone", label: "スマートフォン番号", value: this.newUser.mobilePhone, isRequired: false, maxLength: 11 },
        { field: "department", label: "所在部署名称", value: this.newUser.department, isRequired: true, maxLength: 20 },
        { field: "notes", label: "備考", value: this.newUser.notes, isRequired: false, maxLength: 200 },
        { field: "directAdminOrg", label: "直属行政機関", value: this.newUser.directAdminOrg, isRequired: true },
        { field: "selectedAffiliatedOrgs", label: "所属行政機関", value: this.newUser.selectedAffiliatedOrgs, isRequired: false }
      ]

      // エラーモードを有効化し、バリデーション実行
      this.isErrorMode = true;
      this.errors = this.validateForm(fieldsToValidate);
      
      // エラーチェック
      if (Object.values(this.errors).every((error) => !error)) {
        const token = localStorage.getItem("jwtToken");
        const userId = localStorage.getItem("userId"); // ローカルストレージから userId を取得

        if (!token) {
          alert("ログインしていません。再度ログインしてください。");
          return;
        }

        if (!userId) {
          alert("ログイン情報が見つかりません。再度ログインしてください。");
          return;
        }

        // 利用者区分の設定
        /**
         * 利用者区分について、旧スマートHOKAKUを参考にする
         * あとからDB毎見直してもよさそうだが、ひとまずはこの仕組みで考える
         * 最終的にはスマートHOKAKUに統合する必要があるので一時仕様
         * 末尾が0は管理者
         * 
         * 0000：システム管理者
         * 0100：行政機関・行政機関管理者
         * 0101：行政機関・行政機関メンバー
         * 0210：その他・見える化管理者
         * 0211：その他・見える化メンバー
         * 0201：その他・捕獲者
         */
        let userTypeValue = this.userTypeMapping[this.newUser.userType];
        if (this.newUser.userType === "行政機関") {
          userTypeValue = userTypeValue.concat(this.adminTypeMapping[this.newUser.adminType]);
        } else if (this.newUser.userType === "その他") {
          userTypeValue = userTypeValue.concat(this.otherTypeMapping[this.newUser.otherType]);
        }

        try {
          // サーバーに送信するデータ
          const requestData = {
            region_id: this.newUser.region,
            id: this.newUser.userId,
            password: this.newUser.password,
            section: userTypeValue,
            nameKana: this.newUser.fullNameKana,
            nameKanji: this.newUser.fullNameKanji,
            zip: this.newUser.zip,
            zyuusho1: this.newUser.address1,
            zyuusho2: this.newUser.address2,
            birth: this.newUser.birthday.year + '/' + this.newUser.birthday.month + '/' + this.newUser.birthday.day,
            sex: this.newUser.sex === '不明' ? '0' :
                 this.newUser.sex === '男性' ? '1' :
                 this.newUser.sex === '女性' ? '2' : null,
            tell: this.newUser.homePhone,
            mail: this.newUser.email,
            mobile: this.newUser.mobilePhone,
            departName: this.newUser.department,
            directAdminAgency: this.newUser.directAdminOrg,
            affiliationAdminAgency: this.newUser.selectedAffiliatedOrgs || '',
            addNote: this.newUser.notes,
            creatorId: userId,
          };

          const response = await axios.post(
            `${process.env.VUE_APP_API_BASE_URL}/api/userRegister/register`,
            requestData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          // ステータスコード200の場合（送信成功）
          if (response.status === 201) {
            // 新しいトークンがレスポンスヘッダーに含まれている場合
            const newToken = response.headers.get('Authorization');
            if (newToken) {
                localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
            }
            alert("データが正常に登録されました。");

            // 必要に応じてフォームのリセットや画面遷移を実行
            this.resetForm();          
          } else if (response.status === 202) {
            alert(response.data.message);
          }
        } catch (error) {
          // エラーハンドリング
          if (error.response && error.response.status === 400) {
            alert(error.response.data.message || "リクエストにエラーがあります。");
          } else if (error.response && error.response.status === 401) {
            alert("認証エラー: ログイン情報を確認してください。");
          } else if (error.response && error.response.status === 500) {
            alert("サーバーエラーが発生しました。しばらくしてからお試しください。");
          } else {
            alert("ネットワークエラーが発生しました。接続を確認してください。");
          }
        }
      } else {
        alert("入力エラーがあります。");
      }
    },
    resetForm() {
      this.newUser = {
        userId: '',
        password: '',
        passwordConfirm: '',
        userType: '',
        adminType: [],
        otherType: [],
        email: '',
        fullNameKanji: '',
        fullNameKana: '',
        zip: '',
        address1: '',
        address2: '',
        birthday: { type: '', year: '', month: '', day: '' },
        sex: '',
        homePhone: '',
        mobilePhone: '',
        department: '',
        notes: '',
        directAdminOrg: '',
        selectedAffiliatedOrgs: [],
        userType: '',
        adminType: '',
        otherType: '',
      };
      const section = localStorage.getItem('section');
      if (section != '0000') {
        this.getAffiliatedOrgs();
      }
      this.getRegionDetails();
    },
  },
};
</script>

<style scoped>
.button-column-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.button-column-container button {
  background-color: #4caf50;
  color: white;
  border: none;
}

.button-column-container button:hover {
  background-color: #45a049; /* ホバー時に背景色を濃くする */
  transition: background-color 0.3s ease; /* なめらかな変化を追加 */
}
</style>
